export const genders = ['MISTER', 'MADAME'];
